import { render, staticRenderFns } from "./customer-purchase-history-dialog.vue?vue&type=template&id=6a24b340&scoped=true&"
import script from "./customer-purchase-history-dialog.vue?vue&type=script&lang=js&"
export * from "./customer-purchase-history-dialog.vue?vue&type=script&lang=js&"
import style0 from "./customer-purchase-history-dialog.vue?vue&type=style&index=0&id=6a24b340&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a24b340",
  null
  
)

export default component.exports